import NewOrderDialog from './NewOrderDialog';

export default NewOrderDialog;
